module.exports = {
  messages: {
    ADVERTISING_DIGITAL_SERVICE_ACT_HEADLINE: 'Perché vedo questo annuncio?',
    ADVERTISING_DIGITAL_SERVICE_ACT_POP_UP_FOOTER_CTA: 'Per saperne di più',
    ADVERTISING_DIGITAL_SERVICE_ACT_POP_UP_FOOTER_MESSAGE:
      'relativamente ai criteri del gruppo target.',
    ADVERTISING_DIGITAL_SERVICE_ACT_POP_UP_MESSAGE:
      "Stai vedendo questo annuncio poiché il tuo profilo corrisponde ai criteri dell'inserzionista.",
    ADVERTISING_LEAD_AD_FORM_CHECKBOX_ERROR:
      'Spunta la casella per poter continuare',
    CARDS_SECTION_DESCRIPTION: 'Criteri più popolari nella ricerca lavoro:',
    CARDS_SECTION_REGISTRATION_BUTTON_TEXT:
      'Crea il tuo profilo e comincia subito',
    CARDS_SECTION_REGISTRATION_TEXT:
      'Con un profilo XING puoi moltiplicare le opzioni di ricerca.',
    CARDS_SECTION_TITLE:
      'Una maniera intelligente di scoprire interessanti offerte di lavoro.',
    CAREER_HUB_TEASER_CARD_DESCRIPTION:
      'Utili articoli e suggerimenti di professionisti esperti.',
    CAREER_HUB_TEASER_CARD_TITLE: 'Scopri la Guida alla carriera di XING',
    COMPANIES_SECTION_SUBTITLE:
      'Entra in contatto con le aziende più popolari e con oltre 20.000 recruiter.',
    COMPANIES_SECTION_TITLE:
      'Entra in contatto con le aziende più popolari e con oltre 20.000 recruiter.',
    CP_HIRING: 'Offerte disponibili',
    'CP_TOP_COMPANIES_CARD_BUTTON.one': 'Visualizza {value} offerte',
    'CP_TOP_COMPANIES_CARD_BUTTON.other': 'Visualizza {value} offerte',
    CP_TOP_COMPANIES_CARD_HIGHLIGHT:
      'Il {percentage}% degli utenti ha consigliato questo datore di lavoro su kununu.',
    CRATE_LOSP_CAREER_HUB_CARD_DESCRIPTION:
      'Leggi i migliori articoli e suggerimenti dei nostri professionisti ed esperti.',
    CRATE_LOSP_CAREER_HUB_CARD_TITLE: 'La guida alla carriera di XING',
    CRATE_LOSP_COMPANIES_SECTION_SUBTITLE:
      "Dai un'occhiata alle aziende che stanno assumendo personale.",
    CRATE_LOSP_COMPANIES_SECTION_TITLE:
      'Oltre 270.000 datori di lavoro sono alla ricerca di profili come il tuo ',
    CRATE_LOSP_CV_CARD_DESCRIPTION:
      "Fa una perfetta prima impressione e si crea in un batter d'occhio.",
    CRATE_LOSP_CV_CARD_TITLE: "Crea un CV a regola d'arte in formato PDF",
    CRATE_LOSP_PROFILE_CARD_DESCRIPTION:
      'Creando un profilo XING riceverai le offerte di lavoro in automatico e non ti farai più scappare nessuna opportunità.',
    CRATE_LOSP_PROFILE_CARD_TITLE:
      'Fai in modo che siano gli altri a trovare te!',
    CRATE_LOSP_RECRUITERS_SECTION_SUBTITLE:
      'Entra in contatto con i professionisti HR delle aziende più popolari. ',
    CRATE_LOSP_RECRUITERS_SECTION_TITLE:
      'Oltre 20.000 recruiter stanno cercando personale',
    CRATE_LOSP_REGISTER_BUTTON: 'Crea subito il tuo profilo',
    CRATE_LOSP_REGISTER_WITH_GOOGLE_BUTTON: 'Continua con Apple',
    DESCRIPTION_CARD_1: 'Se preferisci lavorare da casa.',
    DESCRIPTION_CARD_2: 'Lavora quando vuoi.',
    DESCRIPTION_CARD_3:
      "Dai un'occhiata se c'è qualcosa di fattibile anche per te. ",
    DESCRIPTION_CARD_4: 'Ottieni il salario che ti meriti.',
    DESCRIPTION_CARD_5:
      'E dedica il tempo libero rimasto a tutte le altre cose.',
    DESCRIPTION_CARD_6: 'Ecco come iniziare.',
    'DISCO_OBJECTS_FOLLOWER.one': 'follower',
    'DISCO_OBJECTS_FOLLOWER.other': 'follower',
    'DISCO_OBJECTS_FOLLOWER.zero': 'follower',
    ERROR_REGISTER_EMAIL_MAX_CHANGE:
      'Puoi modificare il tuo indirizzo di posta elettronica fino a 10 volte.',
    JOBS_FIND_JOBS_RECRUITERS_LINK:
      'Vuoi postare un annuncio? <a>Puoi farlo qui.</a>',
    JOBS_FIND_JOBS_RECRUITERS_LINK_FIRST_LINE: "Pubblicare l'offerta?",
    JOBS_FIND_JOBS_RECRUITERS_LINK_SECOND_LINE: 'Puoi farlo qui.',
    JOBS_FIND_JOBS_SEARCH_BUTTON: 'Trova un impiego',
    JOBS_FIND_JOBS_SEARCH_LOCATION_PLACEHOLDER: 'Località',
    JOBS_FIND_JOBS_SEARCH_PLACEHOLDER: 'Immetti posizione lavorativa ',
    JOBS_FIND_JOBS_SEARCH_RADIUS_PLACEHOLDER: 'Raggio',
    JOBS_FIND_JOBS_TITLE: 'Trova un impiego',
    JOBS_JOB_TEASER_SAVE: "Salva l'offerta fra i Preferiti",
    JOBS_JOB_TEASER_SAVED: 'Salvato su Favoriti',
    JOBS_LANDING_LO_MARKETING_SEC_ONE_TEXT_ONE: 'Oltre un milione di offerte',
    JOBS_LANDING_LO_MARKETING_SEC_ONE_TEXT_THREE:
      'Webinar sul tema ricerca lavoro ',
    JOBS_LANDING_LO_MARKETING_SEC_ONE_TEXT_TWO: 'Oltre 20 Mio. di utenti',
    JOBS_RECENT_SEARCH_EMPTY: 'Tutte le offerte di lavoro',
    JOBS_SEARCH_AI_HEADLINE: 'Un nuovo modello di ricerca lavoro',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_1: 'Descrivi il lavoro dei tuoi sogni...',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_10:
      'Indica anche le tue esperienze e competenze',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_2:
      'Comunica con un linguaggio naturale...',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_3:
      'Quali sono i lavori che ti piacerebbe fare...',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_4:
      'Le tue idee per la tua prossima opportunità di lavoro...',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_5:
      'Titolo della posizione, livello professionale, aspettativa salariale',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_6:
      'Tutto ciò che per te è importante nella tua vita professionale...',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_7:
      'Più specifiche le informazioni che inserisci, migliori saranno i risultati raggiunti.',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_8:
      'Part time o a tempo pieno, lavoro da casa o da remoto...',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_9:
      'È consigliabile utilizzare frasi semplici piuttosto che numerose parole chiave',
    JOBS_SEARCH_AI_SALARY_SUGGESTION: 'I want to earn more',
    JOBS_SEARCH_AI_SALARY_SUGGESTION_SUBTITLE: 'Find better-paying jobs',
    JOBS_SEARCH_AI_SWIMP_SUGGESTION: 'Cerca con il mio profilo',
    JOBS_SEARCH_AI_SWIMP_SUGGESTION_SUBTITLE:
      "L'IA di XING ti aiuterà a dare il via alla tua prossima fase professionale.",
    JOBS_SEARCH_AI_SWIMS_SUGGESTION: 'Voglio cambiare ambito professionale ',
    JOBS_SEARCH_AI_SWIMS_SUGGESTION_SUBTITLE:
      "L'IA di XING ti mostra tutte le possibilità a disposizione.",
    JOBS_SEARCH_LOCATION_NO_RADIUS: 'Nessun raggio',
    LEAD_AD_FORM_ACCESSIBILITY_LABEL: 'Modulo di contatto',
    LEBENSLAUF_TEASER_CARD_DESCRIPTION:
      "Moltiplica in un batter d'occhio le tue possibilità di ricevere inviti ad un colloquio.",
    LEBENSLAUF_TEASER_CARD_TITLE:
      "Crea un CV a regola d'arte in formato PDF in pochi passi",
    LOADING_ERROR_BODY: 'Per favore, tenta nuovamente.',
    LOADING_ERROR_CTA: 'Tenta nuovamente',
    LOADING_ERROR_HEADLINE: 'Spiacenti, si è verificato un errore.',
    LOGGED_OUT_STARTPAGE_META_DESCRIPTION_JOB_SEARCH:
      'Oltre un milione di offerte ✓ 20.000 recruiter ✓ Dati salariali ✓ Valutazioni datori di lavoro. Definisci le tue preferenze di lavoro e crea il tuo XING!',
    LOGGED_OUT_STARTPAGE_META_TITLE_JOB_SEARCH:
      'Trova il lavoro perfetto per te o fai in modo che sia lui a trovare te.',
    LOSP_APPLE_BUTTON: "Scarica nell'App Store",
    LOSP_GOOGLE_BUTTON: 'Scarica su Google Play',
    LOSP_JOBS_SECTION_SUBTITLE:
      'Offerte più visualizzate su XING nelle ultime settimane.',
    LOSP_JOBS_SECTION_TITLE: 'Le offerte più visualizzate su XING',
    LOSP_KEYWORDS_ACCOUNTANT: '🧮 Accountant',
    LOSP_KEYWORDS_ADMINISTRATION: ' 🏫 amministrazione ',
    LOSP_KEYWORDS_ANALYST: '📈 Data analyst',
    LOSP_KEYWORDS_BANKER: '💸 Banker',
    LOSP_KEYWORDS_CALLCENTER: '📞 Call centre jobs',
    LOSP_KEYWORDS_CAREERCHANGER: '👣 Career changer',
    LOSP_KEYWORDS_CARETAKER: '👨‍🔧 Facility manager',
    LOSP_KEYWORDS_CONTROLLER: '🎚️ Controller',
    LOSP_KEYWORDS_DESIGN: '🎨 Design jobs',
    LOSP_KEYWORDS_FLIGHTATTENDANT: '🛫 Flight attendant',
    LOSP_KEYWORDS_FORKLIFT: '👷 Forklift driver',
    LOSP_KEYWORDS_FOUNDATION: '🏛️ fondazione',
    LOSP_KEYWORDS_FREELANCE: '👨🏻‍💻 Freelance jobs',
    LOSP_KEYWORDS_HEALTH: '🥕 Health manager',
    LOSP_KEYWORDS_LOGISTICS: '📦 Logistics jobs',
    LOSP_KEYWORDS_MARKETING: '📣 Marketing jobs',
    LOSP_KEYWORDS_MUSEUM: '🖼️ Museum jobs',
    LOSP_KEYWORDS_NURSERY: '👶 Nursery teacher',
    LOSP_KEYWORDS_OFFICECLERK: '👩‍💻 Office clerk',
    LOSP_KEYWORDS_PROJECTMANAGER: '🤹 Project manager',
    LOSP_KEYWORDS_PSYCHOLOGIST: '🛋️ Psychologist',
    LOSP_KEYWORDS_SALES: '💼 Field sales representative',
    LOSP_KEYWORDS_SALES2: '💰 Sales jobs',
    LOSP_KEYWORDS_SECURITY: '👮🏻 Security officer',
    LOSP_KEYWORDS_SOCIALMEDIA: '🤳 Social media manager',
    LOSP_KEYWORDS_SOCIALWORKER: '👨‍👧‍👦 Social worker',
    LOSP_KEYWORDS_SOCIALWORKER2: '❤️‍🔥 assistente sociale',
    LOSP_KEYWORDS_SUSTAINABILITY: '🌿 Sustainability jobs',
    LOSP_KEYWORDS_TRUCK: '🚚 Lorry driver',
    LOSP_KEYWORDS_WORKINGSTUDENT: '🧑🏽‍🎓 Working student',
    LOSP_PREFERENCES_EXPERIMENT_CITIES_BERLIN: 'Berlino',
    LOSP_PREFERENCES_EXPERIMENT_CITIES_BUTTON: 'Città',
    LOSP_PREFERENCES_EXPERIMENT_CITIES_HAMBURG: 'Amburgo',
    LOSP_PREFERENCES_EXPERIMENT_CITIES_HEADLINE:
      'In quale città ti piacerebbe lavorare?',
    LOSP_PREFERENCES_EXPERIMENT_CITIES_MUNICH: 'Monaco di Baviera',
    LOSP_PREFERENCES_EXPERIMENT_EMPTY_POPUP_BODY:
      'Indica almeno una preferenza di lavoro e ti segnaleremo offerte di lavoro adatte a te.',
    LOSP_PREFERENCES_EXPERIMENT_EMPTY_POPUP_BUTTON: 'OK',
    LOSP_PREFERENCES_EXPERIMENT_EMPTY_POPUP_HEADLINE:
      'Seleziona almeno una preferenza',
    LOSP_PREFERENCES_EXPERIMENT_HEADLINE:
      'Fai in modo che siano i recruiter a trovare te',
    LOSP_PREFERENCES_EXPERIMENT_LEVEL_BUTTON: 'Livello di carriera ',
    LOSP_PREFERENCES_EXPERIMENT_LEVEL_ENTRY: 'Esordiente nel mondo del lavoro',
    LOSP_PREFERENCES_EXPERIMENT_LEVEL_HEADLINE:
      'In quale livello di carriera dovrebbe rientrare il tuo prossimo lavoro?',
    LOSP_PREFERENCES_EXPERIMENT_LEVEL_MANAGER: 'Manager',
    LOSP_PREFERENCES_EXPERIMENT_LEVEL_PROFESSIONAL: 'Con esperienza',
    LOSP_PREFERENCES_EXPERIMENT_OTHERS_DISCIPLINES: 'Settori di attività',
    LOSP_PREFERENCES_EXPERIMENT_OTHERS_HEADLINE:
      'Hai altre preferenze di lavoro?',
    LOSP_PREFERENCES_EXPERIMENT_OTHERS_INDUSTRIES: 'Settori',
    LOSP_PREFERENCES_EXPERIMENT_OTHERS_JOBTITLE: 'Titolo posizione',
    LOSP_PREFERENCES_EXPERIMENT_OTHERS_WORKING_HOURS: 'Orario di lavoro',
    LOSP_PREFERENCES_EXPERIMENT_PLACE_BUTTON: 'Il tuo posto di lavoro',
    LOSP_PREFERENCES_EXPERIMENT_PLACE_HEADLINE:
      'Come vorresti lavorare in futuro?',
    LOSP_PREFERENCES_EXPERIMENT_PLACE_HOMEOFFICE: 'Al 100 % da casa',
    LOSP_PREFERENCES_EXPERIMENT_PLACE_ONSITE: 'In ufficio',
    LOSP_PREFERENCES_EXPERIMENT_SALARY_BUTTON: 'Salario ',
    LOSP_PREFERENCES_EXPERIMENT_SALARY_EIGHTY: '80.000 €',
    LOSP_PREFERENCES_EXPERIMENT_SALARY_FORTY: '40.000 €',
    LOSP_PREFERENCES_EXPERIMENT_SALARY_FORTY_FIVE: '45.000 €',
    LOSP_PREFERENCES_EXPERIMENT_SALARY_HEADLINE:
      'A quale stipendio annuale aspiri?',
    LOSP_PREFERENCES_EXPERIMENT_SALARY_SIXTY: '60.000 €',
    LOSP_PREFERENCES_EXPERIMENT_SALARY_THIRTY: '30.000 €',
    LOSP_PREFERENCES_EXPERIMENT_SAVE: 'Salva preferenze di lavoro',
    LOSP_PREFERENCES_EXPERIMENT_SAVE_POPUP_BODY:
      'Interessanti aziende e oltre 20.000 recruiter stanno cercando persone come te su XING. Fai in modo che siano loro a trovare te e ricevi offerte veramente il linea con ciò che cerchi: con il il tuo profilo XING.',
    LOSP_PREFERENCES_EXPERIMENT_SAVE_POPUP_BUTTON: 'Registrati subito',
    LOSP_PREFERENCES_EXPERIMENT_SAVE_POPUP_HEADLINE:
      'Lascia che sia il lavoro adatto a trovare te.',
    LOSP_PREFERENCES_EXPERIMENT_SEE_MORE: 'Mostra di più',
    LOSP_PREFERENCES_EXPERIMENT_SUBHEADLINE:
      'Indica le tue preferenze di lavoro e lascia a noi il compito di cercare il lavoro adatto a te.',
    LOSP_PREFERENCES_EXPERIMENT_WORKPLACE_HOME_OFFICE: 'Al 100 % da casa',
    LOSP_PREFERENCES_EXPERIMENT_WORKPLACE_MOSTLY_HOME:
      'Prevalentemente da casa',
    LOSP_PREFERENCES_EXPERIMENT_WORKPLACE_OFFICE: 'In ufficio',
    LOSP_PREFERENCES_EXPERIMENT_WORKPLACE_PARTLY_HOME: 'In parte da casa',
    LOSP_QR_CODE: "Codice QR per scaricare l'app",
    LOSP_RECRUITERS_SECTION_COMPANY_CTA: 'Visualizza le offerte',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_AIRBUS:
      "percentuale di referral dell'80% negli ultimi due anni",
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_AMAZON:
      'Vantaggi per i dipendenti: sconti promozionali, posto auto, eventi per i dipendenti',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_AOK:
      'Oltre 1.440 valutazioni riportano "molto buono"',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_AUDI:
      "l'86 % è soddisfatto del proprio salario",
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_BAHNE_GROTH:
      "Recruiter per posizioni all'interno della sede centrale di flaschenpost",
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_BASF:
      'Benefit confermati più spesso: orari di lavoro flessibili, home office, pensione aziendale',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_BMW:
      'Benefit confermati più spesso: mensa, pensione aziendale, sconti promozionali',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_BOSCH:
      'Benefit confermati più spesso: orari di lavoro flessibili, medico del lavoro',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_CAROLA_LUDEWIG:
      'Assume specialisti della sicurezza di diversi livelli',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_DEUTSCHE_BAHN:
      'percentuale di referral del 74% negli ultimi due anni',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_DEUTSCHE_BANK:
      'Benefit confermati più spesso: orari di lavoro flessibili, pensione aziendale',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_DEUTSCHE_POST:
      'Oltre 12.250 valutazioni di dipendenti e candidati',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_DM:
      'percentuale di referral del 70% negli ultimi due anni',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_DUERENHOFF_GMBH:
      'Classifica top 10 kununu: aziende con le migliori condizioni di lavoro a favore delle famiglie',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_FATMA_KOC:
      'Active Sourcing per il settore dei servizi finanziari',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_FINJA_STRUBER:
      'Recruiter nella sede centrale di ROSSMANN',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_HUSEYIN_YALCIN:
      'Tasso di risposta: meno di 3 secondi',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_IKEA:
      'Benefit confermati più spesso: sconti promozionali, mensa, pensione aziendale',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_ISABEL_STRUSCHKA:
      'Persona di contatto dei settori finanza, IT, persone e cultura',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_JAN_GOTZE:
      'Selezionatore personale manageriale e professionisti IT',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_JAN_SCHENGBER:
      'Tasso di risposta: meno di 4 secondi',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_JOHANNA_ECKERT:
      'Recruiter nel settore auditing, assistenza fiscale e revisione contabile',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_JONAS_MASANNECK:
      'Recruiter nel settore Non-tech & life sciences',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_JULIA_REICHHOFER:
      'Recruiter per tutte le posizioni del gruppo Schmersal ',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_KAUFLAND:
      'Oltre 2.867 valutazioni di dipendenti e candidati',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_KRISTIN_SEMELKA:
      'Recruiter anche nel settore della formazione',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_LIDL: 'kununu Top Company 2023',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_MALTE_BALMER:
      'La tua persona di contatto per le offerte di OTTO',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_MARIA_HEUCKE:
      'Pura passione per il recruiting #WeEmpowerPeople',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_MEINESTADT_DE:
      "percentuale di referral dell'88% negli ultimi due anni",
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_MIRIAM_DJAMBOU:
      'Collocamento di specialisti del settore IT e engineering',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_OTTOBOCK:
      'Benefit confermati più spesso: orari di lavoro flessibili, medico del lavoro',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_PORSCHE:
      'Il 95% è soddisfatto del proprio salario',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_RALPH_OSTERMEIER:
      'La tua persona di contatto per le offerte IT presso EDEKA',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_REWE:
      'percentuale di referral del 61% negli ultimi due anni',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_ROBIN_MAURER:
      'Recruiting & Employer Branding per tre aziende',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_ROSSMANN:
      'Oltre 1.621 valutazioni di dipendenti e candidati',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_SAP:
      'percentuale di  referral del 93% negli ultimi due anni',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_SARAH_BAUDZUS:
      'Più di 10 anni di esperienza nel settore Assistenza e sanità',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_SIEMENS:
      '67 % conferma orari di lavoro flessibili',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_STEFANIE_KLOCK:
      'Collocamento di specialisti del settore Sales & Marketing',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_VANESSA_STRAUCH:
      'Recruiter del settore trasporto e logistica',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_VERONIKA_GERSDORF:
      'Recruiter per la nostra centrale e i nostri uffici',
    LOSP_RECRUITERS_SECTION_RECRUITER_CTA: 'Visualizza profilo',
    LOSP_SEARCH_INSPIRATION_CAREER_LEVEL: 'Il tuo livello professionale',
    LOSP_SEARCH_INSPIRATION_DESCRIPTION_CARD_1:
      'Se preferisci lavorare da casa.',
    LOSP_SEARCH_INSPIRATION_DESCRIPTION_CARD_5:
      'E dedica il tempo libero rimasto a tutto il resto.',
    LOSP_SEARCH_INSPIRATION_DESCRIPTION_CARD_6: 'Ecco come iniziare.',
    LOSP_SEARCH_INSPIRATION_PREFERENCES_CAREER_LEVEL_HEADLINE:
      'Qual è il tuo livello professionale preferito?',
    LOSP_SEARCH_INSPIRATION_PREFERENCES_DESCRIPTION:
      'Seleziona ciò che per te è importante così potremo inviarti segnalazioni più in linea con ciò che cerchi.',
    LOSP_SEARCH_INSPIRATION_PREFERENCES_DESCRIPTION_2:
      'Ci vorrà solo un momento.',
    LOSP_SEARCH_INSPIRATION_PREFERENCES_MODAL_SUBHEADLINE:
      'Seleziona ciò che per te è importante così potremo inviarti segnalazioni più in linea con ciò che cerchi. Ci vorrà solo un momento.',
    LOSP_SEARCH_INSPIRATION_PREFERENCES_MODAL_TITLE:
      'Le tue preferenze di lavoro',
    LOSP_SEARCH_INSPIRATION_PREFERENCES_SALARY_HEADLINE:
      'Quali sono le tue aspettative salariali?',
    LOSP_SEARCH_INSPIRATION_PREFERENCES_TITLE: 'Le tue preferenze di lavoro',
    LOSP_SEARCH_INSPIRATION_PREFERENCES_WORKPLACE_HEADLINE:
      'Come vorresti lavorare in futuro?',
    LOSP_SEARCH_INSPIRATION_SALARY: 'Le tue aspettative salariali',
    LOSP_SEARCH_INSPIRATION_SET_PREFERENCES: 'Salva preferenze di lavoro',
    LOSP_SEARCH_INSPIRATION_TITLE_CARD_1: 'Offerte lavoro da remoto',
    LOSP_SEARCH_INSPIRATION_TITLE_CARD_3:
      'Offerte per chi è interessato a cambiare ambito professionale ',
    LOSP_SEARCH_INSPIRATION_WORKPLACE: 'Il tuo posto di lavoro',
    LOSP_SEO_SECTION_COMPANIES_DIRECTORY: 'Aziende dalla A alla Z',
    LOSP_SEO_SECTION_HEADER_DIRECTORIES: 'Directory ',
    LOSP_SEO_SECTION_HEADER_JOB_ROLES: 'Posizioni lavorative',
    LOSP_SEO_SECTION_HEADER_TOP_LOCATIONS: 'Top location',
    LOSP_SEO_SECTION_HEADER_TOP_SKILLS: 'Competenze chiave',
    LOSP_SEO_SECTION_JOBS_DIRECTORY: 'Offerte dalla A alla Z',
    LOSP_SEO_SECTION_PEOPLE_DIRECTORY: 'Membri dalla A alla Z',
    MORE_OPTIONS_ACCESSIBILITY_LABEL: 'Altre opzioni',
    NATIVE_ADS_DOT_MENU_REPORT_OBJECT: "Segnala l'annuncio ",
    NATIVE_ADS_LEARN_MORE_BUTTON: 'Scopri di più',
    NATIVE_ADS_SPONSORED_LABEL: 'Sponsorizzato',
    NETWORK_DIRECT_CONNECTIONS_HIRING_HIGHLIGHTS_CTA: 'Mostra dettagli',
    NETWORK_MY_NETWORK_BOOST_ME_UP_BANNER_CTA: 'Jetzt Profil boosten',
    NETWORK_MY_NETWORK_BOOST_ME_UP_BANNER_HEADLINE_1: 'Schneller zum',
    NETWORK_MY_NETWORK_BOOST_ME_UP_BANNER_HEADLINE_2: 'nächsten Job',
    NETWORK_MY_NETWORK_BOOST_ME_UP_BANNER_PRE_HEADLINE: 'Kostenlos für Dich',
    NETWORK_MY_NETWORK_BOOST_ME_UP_BANNER_SUBLINE:
      'Heb Dein Profil 14 Tage lang für Recruiter·innen hervor und sicher Dir die Chance auf mehr Job-Angebote.',
    NETWORK_MY_NETWORK_PROFILE_COMPLETION_CARD_CTA_100: 'Aggiorna profilo',
    NETWORK_MY_NETWORK_PROFILE_COMPLETION_CARD_DESCRIPTION_100:
      'Verifica regolarmente che le informazioni siano sempre attuali.\n',
    NETWORK_MY_NETWORK_ROMP_BASIC_BANNER_GET_PROJOBS_CTA: 'Attiva ProJobs',
    NETWORK_MY_NETWORK_ROMP_BASIC_NO_VISITORS_BANNER_BODY:
      'Passa a ProJobs per aumentare la tua visibilità ed essere trovato con più frequenza.',
    NETWORK_MY_NETWORK_ROMP_BASIC_NO_VISITORS_BANNER_HEADLINE:
      'Quali professionisti HR sono interessati al tuo profilo?',
    NETWORK_MY_NETWORK_ROMP_BASIC_WITH_VISITORS_BANNER_BODY:
      'Alcuni professionisti HR hanno visitato il tuo profilo. Passa a ProJobs per scoprire chi sono.',
    NETWORK_MY_NETWORK_ROMP_BASIC_WITH_VISITORS_BANNER_HEADLINE:
      'Chi è interessato al tuo profilo?',
    NETWORK_MY_NETWORK_ROMP_BASIC_WITH_VISITORS_BANNER_VIEW_ALL_VISITS_CTA:
      'Visualizza tutte le visite',
    NETWORK_MY_NETWORK_ROMP_BASIC_WITH_VISITORS_VISITOR_FENCED_NAME:
      'Recruiter',
    NETWORK_MY_NETWORK_ROMP_EMPTY_STATE_BODY:
      'Amplia la tua rete di contatti in modo tale da ottimizzare la tua visibilità e attrarre più visitatori al tuo profilo.',
    NETWORK_MY_NETWORK_ROMP_EMPTY_STATE_CTA:
      'Scopri i professionisti del settore HR',
    NETWORK_MY_NETWORK_ROMP_EMPTY_STATE_HEADLINE:
      'Ancora nessuna visita da parte dei recruiter?',
    NETWORK_MY_NETWORK_ROMP_PREMIUM_REASSURANCE_BODY:
      'Premium ti permette di vedere i recruiter che hanno visualizzato il tuo profilo. ',
    NETWORK_MY_NETWORK_ROMP_PREMIUM_REASSURANCE_CTA:
      'Visualizza tutti i vantaggi Premium',
    NETWORK_MY_NETWORK_ROMP_PREMIUM_REASSURANCE_HEADLINE:
      'Scopri i professionisti del settore HR che sono interessati a te.',
    NETWORK_MY_NETWORK_ROMP_PROJOBS_REASSURANCE_BODY:
      'ProJobs ti permette di vedere i recruiter che hanno visualizzato il tuo profilo. ',
    NETWORK_MY_NETWORK_ROMP_PROJOBS_REASSURANCE_CTA:
      'Scopri tutti i vantaggi ProJobs',
    NETWORK_MY_NETWORK_ROMP_PROJOBS_REASSURANCE_HEADLINE:
      'Scopri i professionisti del settore HR che sono interessati a te.',
    NETWORK_MY_NETWORK_ROMP_VISITORS_ACCEPT_CONTACT_REQUEST: 'Accetta',
    NETWORK_MY_NETWORK_ROMP_VISITORS_ADD_SEND_CONTACT_REQUEST:
      'Aggiungi contatto',
    NETWORK_MY_NETWORK_ROMP_VISITORS_DECLINE_CONTACT_REQUEST: 'Rifiuta',
    NETWORK_MY_NETWORK_ROMP_VISITORS_EXTERNAL_RECRUITER: 'Visitatore esterno',
    NETWORK_MY_NETWORK_ROMP_VISITORS_HEADLINE:
      ' Professionisti HR interessati al tuo profilo',
    NETWORK_MY_NETWORK_ROMP_VISITORS_SHOW_MORE_BUTTON: 'Mostra di più',
    NETWORK_MY_NETWORK_ROMP_VISITORS_TIME_FRAME: 'Negli ultimi 90 giorni',
    NETWORK_MY_NETWORK_ROMP_VISITORS_WRITE_MESSAGE: 'Scrivi messaggio',
    NETWORK_MY_NETWORK_VISIBILITY_BANNER_CTA: 'Ottimizza il tuo profilo',
    NETWORK_MY_NETWORK_VISIBILITY_BANNER_DESCRIPTION:
      "Completa le voci del tuo profilo per aumentare le probabilità d'essere trovato.",
    NETWORK_MY_NETWORK_VISIBILITY_BANNER_TITLE: 'Qualità del profilo',
    NETWORK_MYMK_ABOUT_ME_TITLE: 'Chi sono',
    NETWORK_MYMK_SHOW_MORE_BUTTON: 'Mostra di più',
    NETWORK_MYMK_TOTAL_SHARED_CONTACTS_WEB: 'Contatti in comune',
    NETWORK_MYNETWORK_BIRTHDAY_EMPTY:
      'Nessun dei tuoi contatti compie oggi gli anni.',
    NETWORK_MYNETWORK_BIRTHDAY_HAS_BIRTHDAY: 'compie gli anni.',
    NETWORK_MYNETWORK_BIRTHDAY_HEADLINE: 'Compleanni',
    NETWORK_MYNETWORK_BIRTHDAY_MULTIPLE_CONTACTS_HAVE:
      '{count} dei tuoi contatti festeggiano',
    NETWORK_MYNETWORK_BIRTHDAY_ONE_CONTACT_HAS: 'Uno dei tuoi contatti',
    NETWORK_MYNETWORK_BIRTHDAY_TODAY: 'il compleanno oggi.',
    NETWORK_MYNETWORK_BIRTHDAY_TODAY_BECOMES_AGE: 'compie oggi {age} anni.',
    NETWORK_MYNETWORK_BIRTHDAY_TWO_CONTACTS_HAVE:
      '{name1} e {name2} festeggiano',
    NETWORK_MYNETWORK_BIRTHDAY_WILL_BECOME_AGE: 'il {date} compie {age} anni.',
    NETWORK_MYNETWORK_BIRTHDAY_WILL_BECOME_AGE_NO_DATE: 'compie {age} anni.',
    NETWORK_MYNETWORK_BIRTHDAY_WILL_HAVE_BIRTHDAY: 'compie gli anni il {date}.',
    NETWORK_MYNETWORK_BIRTHDAY_WILL_HAVE_BIRTHDAY_NO_DATE: 'compie gli anni.',
    NETWORK_MYNETWORK_CONTACT_HEADLINE: 'Contatti',
    NETWORK_MYNETWORK_CONTACT_MULTIPLE: 'Hai <b>{count} contatti</b>.',
    NETWORK_MYNETWORK_CONTACT_REQUEST_COMMON_CONTACTS:
      '{amount} contatti in comune',
    NETWORK_MYNETWORK_CONTACT_REQUEST_EMPTY_HEADLINE:
      'Nessuna richiesta di contatto',
    NETWORK_MYNETWORK_CONTACT_REQUEST_HEADLINE: 'Richieste di contatto',
    NETWORK_MYNETWORK_CONTACT_REQUEST_MULTIPLE_HEADLINE:
      'Hai <b>{count} richieste di contatto in sospeso</b>\n',
    NETWORK_MYNETWORK_CONTACT_REQUEST_SINGLE_HEADLINE:
      'Hai <b>una nuova richiesta di contatto:</b>',
    NETWORK_MYNETWORK_CONTACT_REQUEST_TWO_REQUESTS: 'di {name1} e {name2}.',
    NETWORK_MYNETWORK_CONTACT_REQUEST_VIEW_ALL:
      'Visualizza tutte le richieste di contatto',
    NETWORK_MYNETWORK_CONTACT_REQUESTS_EMPTY_STATE_CTA1:
      'Scopri nuovi contatti interessanti',
    NETWORK_MYNETWORK_CONTACT_REQUESTS_EMPTY_STATE_CTA2:
      'Vedi tutte le richieste',
    NETWORK_MYNETWORK_CONTACT_REQUESTS_EMPTY_STATE_DESCRIPTION:
      'Stabilisci nuovi contatti e sfrutta le potenzialità del networking.',
    NETWORK_MYNETWORK_CONTACT_REQUESTS_EMPTY_STATE_SUBLINE:
      'Questa sezione è vuota al momento.',
    NETWORK_MYNETWORK_CONTACT_REQUESTS_EMPTY_STATE_TITLE:
      'Richieste di contatto',
    NETWORK_MYNETWORK_CONTACT_SEARCH_PLACEHOLDER: 'Cerca fra i contatti',
    NETWORK_MYNETWORK_CONTACT_SINGLE: 'Hai <b>{count} contatto</b>.',
    NETWORK_MYNETWORK_DEFAULT_ERROR_MESSAGE:
      'Spiacenti, si è verificato un errore. Tenta nuovamente.',
    NETWORK_MYNETWORK_EMPTY_STATE_DESCRIPTION:
      'Stabilisci nuovi contatti e sfrutta le potenzialità del networking.',
    NETWORK_MYNETWORK_EMPTY_STATE_HEADLINE:
      'Questa sezione è vuota al momento.',
    NETWORK_MYNETWORK_HEADLINE: 'Il tuo network',
    NETWORK_MYNETWORK_HEADLINE_WEB: 'Network',
    NETWORK_MYNETWORK_HIRING_HIGHLIGHTS_BANNER_CONFIRMATION_CTA:
      'Mostra dettagli',
    NETWORK_MYNETWORK_HIRING_HIGHLIGHTS_BANNER_CONFIRMATION_TEXT:
      "Fatto, abbiamo eseguito l'aggiornamento.",
    NETWORK_MYNETWORK_HIRING_HIGHLIGHTS_BANNER_NO_CTA: 'Non al momento.',
    NETWORK_MYNETWORK_HIRING_HIGHLIGHTS_BANNER_SUBLINE:
      'Indica le competenze che stai cercando su XING e attrai così i migliori candidati. ',
    NETWORK_MYNETWORK_HIRING_HIGHLIGHTS_BANNER_TITLE:
      'Ciao {firstname}. Sei alla ricerca di talenti?',
    NETWORK_MYNETWORK_HIRING_HIGHLIGHTS_BANNER_YES_CTA: 'Sì, stiamo assumendo.',
    NETWORK_MYNETWORK_MEMBER_SEARCH_HEADLINE: 'Trova utenti',
    NETWORK_MYNETWORK_MEMBER_SEARCH_PLACEHOLDER: "Indica il nome o l'azienda",
    NETWORK_MYNETWORK_MYMK_HEADLINE: 'Iscritti',
    NETWORK_MYNETWORK_NUM_CONTACTS:
      '{count, number} {count, plural,\n  one {contatto.}\n  other {contatti.}\n}',
    NETWORK_MYNETWORK_PROFILE_VISITORS_CTA_BASIC: 'Passa a Premium',
    NETWORK_MYNETWORK_PROFILE_VISITORS_CTA_PREMIUM:
      'Visualizza visite al profilo',
    NETWORK_MYNETWORK_PROFILE_VISITORS_DESCRIPTION_BASIC:
      'In qualità di utente Premium puoi vedere chi ha visitato il tuo profilo e perché. ',
    NETWORK_MYNETWORK_PROFILE_VISITORS_DESCRIPTION_PREMIUM:
      'Scopri chi ha visitato il tuo profilo, quando e perché e amplia così il tuo network.',
    NETWORK_MYNETWORK_PROFILE_VISITORS_ENTRYPOINT_CTA: 'Visualizza tutti',
    NETWORK_MYNETWORK_PROFILE_VISITORS_ENTRYPOINT_HEADLINE:
      'Vuoi sapere chi ha mostrato interesse per il tuo profilo?',
    NETWORK_MYNETWORK_PROFILE_VISITORS_HEADLINE: 'Visite al profilo',
    NETWORK_MYNETWORK_PROFILE_VISITORS_NUMBER_OF_VISITS: 'Visite',
    NETWORK_MYNETWORK_RECOMMENDATIONS_COMPANIES: 'Siete colleghi',
    NETWORK_MYNETWORK_RECOMMENDATIONS_COMPANIES_CONTACTS_MANY:
      'Lavorate per la stessa azienda e avete {count} contatti in comune.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_COMPANIES_CONTACTS_ONE:
      'Siete colleghi e avete un contatto in comune.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_COMPANIES_CONTACTS_PRIVATE:
      'Siete colleghi e avete contatti in comune.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_COMPANIES_EVENTS:
      'Siete colleghi e avete partecipato agli stessi eventi.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_COMPANIES_GROUPS:
      'Siete colleghi e siete iscritti agli stessi gruppi.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_COMPANIES_PAST: 'Siete stati colleghi.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_COMPANIES_PAST_CONTACTS_MANY:
      'Siete ex colleghi e avete contatti in comune.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_COMPANIES_PAST_CONTACTS_ONE:
      'Siete ex colleghi e avete un contatto in comune.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_COMPANIES_PAST_CONTACTS_PRIVATE:
      'Avete lavorato per la stessa azienda e avete contatti in comune.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_COMPANIES_PAST_EVENTS:
      'Siete ex colleghi e avete preso parte agli stessi eventi.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_COMPANIES_PAST_GROUPS:
      'Siete colleghi di lavoro e anche membri degli stessi gruppi.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_CONTACTS_GROUPS_MANY:
      'Avete {count} contatti in comune e siete iscritti agli stessi gruppi.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_CONTACTS_GROUPS_ONE:
      'Avete un contatto in comune e siete iscritti agli stessi gruppi.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_CONTACTS_GROUPS_PRIVATE:
      'Avete contatti in comune e siete iscritti agli stessi gruppi.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_CONTACTS_MANY:
      'Avete {count} contatti in comune.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_CONTACTS_ONE:
      'Avete un contatto in comune.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_CONTACTS_PRIVATE:
      'Avete contatti in comune.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_CTA: 'Aggiungi',
    NETWORK_MYNETWORK_RECOMMENDATIONS_EMAIL_CONTACT:
      'Uno dei tuoi contatti e-mail',
    NETWORK_MYNETWORK_RECOMMENDATIONS_EVENTS:
      'Avete partecipato agli stessi eventi.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_EVENTS_CONTACTS_MANY:
      'Avete partecipato agli stessi eventi e avete {count} contatti in comune.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_EVENTS_CONTACTS_ONE:
      'Avete contatti in comune e avete partecipato agli stessi eventi.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_EVENTS_CONTACTS_PRIVATE:
      'Avete contatti in comune e avete partecipato agli stessi eventi.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_EVENTS_GROUPS:
      'Siete iscritti agli stessi gruppi e avete partecipato agli stessi eventi.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_GROUPS:
      'Siete iscritti agli stessi gruppi.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_HEADLINE:
      'Amplia qui la tua rete di contatti personale:',
    NETWORK_MYNETWORK_RECOMMENDATIONS_SEND_MESSAGE: 'Invia messaggio',
    NETWORK_MYNETWORK_RECOMMENDATIONS_SUBLINE:
      "C'è qualche viso conosciuto? Allora entra in contatto con loro.",
    NETWORK_MYNETWORK_RECRUITER_INTERACTIONS_CTA_BASIC: 'Passa a ProJobs',
    NETWORK_MYNETWORK_RECRUITER_INTERACTIONS_CTA_PROJOBS: 'Visualizza dettagli',
    NETWORK_MYNETWORK_RECRUITER_INTERACTIONS_DESCRIPTION_BASIC:
      'Scopri quali professionisti del settore HR hanno visitato e salvato il tuo profilo con <b>ProJobs</b> e sblocca tutti i vantaggi Premium e ProJobs.',
    NETWORK_MYNETWORK_RECRUITER_INTERACTIONS_DESCRIPTION_PROJOBS:
      'Scopri quali professionisti del settore HR hanno visitato e salvato il tuo profilo.',
    NETWORK_MYNETWORK_RECRUITER_INTERACTIONS_HEADLINE:
      'Interazioni con i recruiter',
    NETWORK_MYNETWORK_RECRUITER_INTERACTIONS_NUMBER_OF_BOOKMARKS:
      'E-mail salvata',
    NETWORK_MYNETWORK_RECRUITER_INTERACTIONS_NUMBER_OF_SEARCHES:
      'Risultati di ricerca',
    NETWORK_MYNETWORK_RECRUITER_INTERACTIONS_TOTAL: 'Interazioni',
    NETWORK_MYNETWORK_RECRUITERS_CTA: 'Visualizza profilo',
    NETWORK_MYNETWORK_RECRUITERS_DESCRIPTION:
      "Dai un'occhiata al loto profilo e valuta se inviare un messaggio. Potrebbe essere una buona idea stabilire già un primo contatto.",
    NETWORK_MYNETWORK_RECRUITERS_HEADLINE:
      'Recruiter che cercano spesso le competenze che hai tu.',
    NETWORK_MYNETWORK_RECRUITERS_HIRING_DISCIPLINE:
      'è spesso alla ricerca di personale per il tuo campo di attività. ',
    NETWORK_MYNETWORK_RECRUITERS_HIRING_INDUSTRY:
      'è spesso alla ricerca di personale per il tuo settore. ',
    NETWORK_MYNETWORK_RECRUITERS_HIRING_JOB_ROLE:
      'è spesso alla ricerca di personale per posizioni come la tua. ',
    NETWORK_MYNETWORK_RECRUITERS_MARKER_HIRING: 'Sta assumendo',
    NETWORK_MYNETWORK_RECRUITERS_RECOMMENDATIONS_SEE_MORE_CTA:
      "Dai un'occhiata",
    NETWORK_MYNETWORK_RECRUITERS_RECOMMENDATIONS_SEE_MORE_TEXT:
      "C'è molto altro ancora da scoprire.",
    NETWORK_MYNETWORK_TIPBOX_CTA: 'Avanti',
    NETWORK_MYNETWORK_TIPBOX_CTA_FINAL: 'Ok',
    NETWORK_MYNETWORK_TIPBOX_MARKER: 'Novità',
    NETWORK_MYNETWORK_TIPBOX_PROFILE_VISITORS_DESCRIPTION:
      'Scopri chi ha visitato il tuo profilo, quando e perché.',
    NETWORK_MYNETWORK_TIPBOX_PROFILE_VISITORS_TITLE: 'Visite al profilo',
    NETWORK_MYNETWORK_TIPBOX_PROFILE_VISITS_DESCRIPTION:
      'Qui puoi accedere alla panoramica completa di tutte le visite al tuo profilo.',
    NETWORK_MYNETWORK_TIPBOX_PROFILE_VISITS_TITLE: 'Tutte le statistiche',
    NETWORK_MYNETWORK_TIPBOX_RECRUITER_INTERACTIONS_DESCRIPTION:
      "Dai un'occhiata a quali professionisti HR hanno visitato il tuo profilo.",
    NETWORK_MYNETWORK_TIPBOX_RECRUITER_INTERACTIONS_TITLE:
      'Interazioni con i recruiter',
    NETWORK_MYNETWORK_TIPBOX_SEARCH_MEMBERS_DESCRIPTION:
      'Trova utenti XING indicando un nome o una azienda.',
    NETWORK_MYNETWORK_TIPBOX_SEARCH_MEMBERS_TITLE: 'Trova utenti',
    NETWORK_RECOMMENDATION_CATEGORY_ALL: 'Tutto',
    NETWORK_RECOMMENDATION_CATEGORY_COWORKER_CURRENT: 'Colleghi',
    NETWORK_RECOMMENDATION_CATEGORY_COWORKER_PREVIOUS: 'Ex colleghi',
    NETWORK_RECOMMENDATION_CATEGORY_NEW_CONNECTIONS: 'New connections',
    NETWORK_RECOMMENDATION_CATEGORY_RECOMMENDATIONS: 'Segnalazioni',
    NETWORK_RECOMMENDATION_CATEGORY_SHARE_CONTACTS: 'Contatti in comune',
    NETWORK_RECOMMENDATION_CATEGORY_SIMILAR_CAREER_PATH: 'Profili simili',
    NETWORK_RECOMMENDATIONS_ACCEPTED_START_CONVERSATION:
      'Perché non cominciare subito una conversazione?',
    NETWORK_RECOMMENDATIONS_ACCEPTED_SUCCESS:
      '{userName} è stato aggiunto ai tuoi contatti.',
    NETWORK_RECOMMENDATIONS_EMPTY_STATE_TIP_1:
      'Il tuo percorso professionale (ovvero tutte le tue esperienze professionali e il tuo percorso di studi)',
    NETWORK_RECOMMENDATIONS_EMPTY_STATE_TIP_2:
      'Le associazioni o organizzazioni di cui sei membro',
    NETWORK_RECOMMENDATIONS_EMPTY_STATE_TIPS_COPY:
      'Fatto! Ora siamo in grado di suggerirti contatti interessanti per te.',
    NETWORK_RECOMMENDATIONS_EMPTY_STATE_TIPS_CTA: 'Completa il tuo profilo',
    NETWORK_RECOMMENDATIONS_EMPTY_STATE_TIPS_HEADLINE:
      'Desideri ricevere suggerimenti di contatti da parte di XING? Allora completa i seguenti campi del tuo profilo:',
    NETWORK_RECOMMENDATIONS_SEND_MESSAGE:
      'Le associazioni o organizzazioni di cui sei membro',
    NETWORK_RECOMMENDATIONS_SENT_HEADLINE:
      'La tua richiesta di contatto a {userName} è stata inviata.',
    NETWORK_RECOMMENDATIONS_SENT_SENT_MESSAGE_BASIC:
      'Entra in contatto con altri utenti.',
    NETWORK_RECOMMENDATIONS_SENT_SENT_MESSAGE_PREMIUM:
      'Invia subito un saluto.',
    NETWORK_REQUEST_ERROR_DIALOG_CONTACT_LIMIT_REACHED_CTA:
      'Vai alle richieste inviate',
    NETWORK_REQUEST_ERROR_DIALOG_CONTACT_LIMIT_REACHED_HEADLINE:
      'Siete iscritti agli stessi gruppi.',
    NETWORK_REQUEST_ERROR_DIALOG_CONTACT_LIMIT_REACHED_TEXT:
      'Siete iscritti agli stessi gruppi.',
    NETWORK_REQUESTS_BUTTON_ACCEPT: 'Accetta',
    NETWORK_REQUESTS_BUTTON_REPORT_SPAM: 'Segnala come spam',
    NETWORK_REQUESTS_BUTTON_SEND_MESSAGE: 'Invia messaggio',
    NETWORK_REQUESTS_DIALOG_CANCEL: 'Annulla',
    NETWORK_REQUESTS_DIALOG_DECLINE_HEADLINE: 'Elimina richiesta di contatto?',
    NETWORK_REQUESTS_DIALOG_DECLINE_TEXT: "L'utente non verrà notificato.",
    NETWORK_REQUESTS_DIALOG_DENY: 'Elimina richiesta',
    NETWORK_REQUESTS_DIALOG_SEND: 'Invia',
    NETWORK_REQUESTS_EMPTY_STATE_CTA: 'Scopri nuovi contatti',
    NETWORK_REQUESTS_HEADLINE: 'Richieste di contatto',
    NETWORK_REQUESTS_MODAL_OPEN_ARIA_LABEL:
      'Richieste ricevute nel modale aperto',
    NETWORK_REQUESTS_RECEIVED_SPAM_HEADER:
      'Segnala questo messaggio come spam o {age}',
    NETWORK_REQUESTS_RECEIVED_SPAM_TEXT:
      'Per favore aiutaci a verificare al meglio la tua segnalazione informandoci sul perchè ritieni che questo post sia da considerare come spam. Grazie! ',
    NETWORK_REQUESTS_TABNAV_RECEIVED: 'Richieste ricevute',
    NETWORK_SEARCH_AND_SWIPE_ABOUT_BUTTON_LABEL: 'OK',
    NETWORK_SEARCH_AND_SWIPE_BOTTOM_SHEET_ABOUT_THIS_FEATURE:
      'Scopri di più su questa funzionalità',
    NETWORK_SEARCH_AND_SWIPE_BOTTOM_SHEET_RESTART_TUTORIAL:
      'Rivedi il tutorial',
    NETWORK_SEARCH_AND_SWIPE_CONTACT_REQUEST_LIMIT_DESCRIPTION_WEB:
      "You've reached your limit of 100 sent contact requests. To send more, please review and manage your pending requests.\n{br}<a>View all contacts> Sent requests</a>",
    NETWORK_SEARCH_AND_SWIPE_CONTACT_REQUEST_LIMIT_TITLE:
      'Review your sent contact requests',
    NETWORK_SEARCH_AND_SWIPE_CONTACT_REQUEST_LIMIT_WARNING_BUTTON:
      'Scorri a destra',
    NETWORK_SEARCH_AND_SWIPE_CONTACT_REQUEST_LIMIT_WARNING_MESSAGE:
      'Scorri a destra',
    NETWORK_SEARCH_AND_SWIPE_CONTACT_REQUEST_LIMIT_WARNING_TITLE:
      'Scorri a destra',
    NETWORK_SEARCH_AND_SWIPE_DISCARD_RECOMMENDATION_BUTTON_A11Y:
      'Rifiuta suggerimento di contatto',
    NETWORK_SEARCH_AND_SWIPE_MYMK_EMPTY_CARD_DESCRIPTION:
      'Il nostro obiettivo è suggerirti contatti realmente rilevanti per la tua rete. Completa il tuo profilo per aiutarci a capire meglio chi potrebbe essere interessante per il tuo network.',
    NETWORK_SEARCH_AND_SWIPE_MYMK_EMPTY_CARD_TITLE:
      'Nessun suggerimento di contatto corrispondente',
    NETWORK_SEARCH_AND_SWIPE_MYMK_NO_MORE_RECOMMENDATIONS_DESCRIPTION:
      'Aggiornare il tuo profilo per ricevere suggerimenti di contatti più mirati e di qualità. Così potremo identificare con maggiore precisione chi può essere rilevante per la tua rete professionale.',
    NETWORK_SEARCH_AND_SWIPE_MYMK_NO_MORE_RECOMMENDATIONS_TITLE:
      'Per il momento è tutto.',
    NETWORK_SEARCH_AND_SWIPE_PRIVACY_CONTACT_REQUEST_FAILURE_MESSAGE:
      'Non è stato possibile inviare tua richiesta di contatto.',
    NETWORK_SEARCH_AND_SWIPE_PRIVACY_CONTACT_REQUEST_SUCESS_MESSAGE:
      'La tua richiesta di contatto è stata inviata.',
    NETWORK_SEARCH_AND_SWIPE_PRIVACY_POLICY_DESCRIPTION_WEB:
      'Durante lo swipe, l’aggiunta o l’eliminazione di profili consigliati, gli altri utenti saranno informati che hai visualizzato parte o tutto il loro profilo. Per ulteriori dettagli, ti invitiamo a consultare la sezione Clickpath della nostra <a>Informativa sulla privacy</a>.',
    NETWORK_SEARCH_AND_SWIPE_PRIVACY_POLICY_LINK:
      'https://privacy.xing.com/en/privacy-policy/information-we-automatically-receive-through-your-use-of-xing/provision-of-our-service/examples',
    NETWORK_SEARCH_AND_SWIPE_PRIVACY_POLICY_TITLE: 'About this feature',
    NETWORK_SEARCH_AND_SWIPE_SEND_CONTACT_REQUEST_BUTTON_A11Y:
      'Invia richiesta di contatto',
    NETWORK_SEARCH_AND_SWIPE_TUTORIAL_CONTACT_REQUESTS_HINT_DESCRIPTION_WEB:
      'Se desideri modificare una <a>richiesta di contatto</a> inviata o verificare chi vuole aggiungerti alla sua rete, visita la pagina delle richieste inviate.',
    NETWORK_SEARCH_AND_SWIPE_TUTORIAL_CONTACT_REQUESTS_HINT_TITLE:
      'Verifica le tue richieste di contatto',
    NETWORK_SEARCH_AND_SWIPE_TUTORIAL_INTO_DESCRIPTION:
      'Esplora le funzionalità aggiornate e le modalità di interazione disponibili in questa sezione.',
    NETWORK_SEARCH_AND_SWIPE_TUTORIAL_INTO_TITLE_WEB:
      'Benvenuto nella nuova area dedicata alla tua rete professionale',
    NETWORK_SEARCH_AND_SWIPE_TUTORIAL_LEGAL_NOTE_DESCRIPTION_WEB:
      'Durante lo swipe, l’aggiunta o l’eliminazione di profili consigliati, gli altri utenti saranno informati che hai visualizzato parte o tutto il loro profilo. Per ulteriori dettagli, ti invitiamo a consultare la sezione Clickpath della nostra <a>Informativa sulla privacy</a>.',
    NETWORK_SEARCH_AND_SWIPE_TUTORIAL_LEGAL_NOTE_TITLE: 'Ultima cosa',
    NETWORK_SEARCH_AND_SWIPE_TUTORIAL_SWIPE_LEFT_DESCRIPTION_WEB:
      'Scorrendo a sinistra, rifiuti una richiesta di contatto.',
    NETWORK_SEARCH_AND_SWIPE_TUTORIAL_SWIPE_LEFT_TITLE: 'Scorri a sinistra',
    NETWORK_SEARCH_AND_SWIPE_TUTORIAL_SWIPE_RIGHT_DESCRIPTION_WEB:
      'Scorrendo a destra invii una richiesta di contatto. Il destinatario potrà quindi valutare e decidere se accettarla o meno.',
    NETWORK_SEARCH_AND_SWIPE_TUTORIAL_SWIPE_RIGHT_TITLE: 'Scorri a destra',
    PROFILE_TEASER_CARD_DESCRIPTION:
      'È gratuito e moltiplicherà le tue chance per la tua ricerca di un nuovo lavoro.',
    PROFILE_TEASER_CARD_TITLE: 'Crea il tuo profilo XING',
    QR_CODE_BANNER_SUBTITLE: 'il tuo nuovo lavoro è ad un solo passo da te.',
    QR_CODE_BANNER_TITLE: "Scarica l'app di XING",
    REASSURANCE_ARIA_LABEL: '{variant} badge',
    RECRUITERS_SECTION_FIRST_SUBTITLE:
      'Creando un profilo XING riceverai le offerte di lavoro in automatico e non ti farai più scappare nessuna opportunità.',
    RECRUITERS_SECTION_FIRST_TITLE: 'O fatti trovare',
    RECRUITERS_SECTION_FLAG_COMPANIES: 'Offerte disponibili',
    RECRUITERS_SECTION_FLAG_RECRUITERS: 'Sta assumendo',
    RECRUITERS_SECTION_REGISTER_BUTTON: 'Crea il tuo profilo e comincia subito',
    RECRUITERS_SECTION_REGISTER_WITH_GOOGLE_BUTTON: 'Prosegui con Google',
    RECRUITERS_SECTION_SECOND_SUBTITLE:
      'Entra in contatto con le aziende più popolari e con oltre 20.000 recruiter.',
    RECRUITERS_SECTION_SECOND_TITLE: 'Stabilisci le connessioni opportune.',
    REGISTER_SECTION_DATE_MARK: 'Oggi',
    REGISTER_SECTION_FIRST_TAG: 'Le tue aspettative di retribuzione',
    REGISTER_SECTION_HEADLINE: '4 nuove richieste',
    REGISTER_SECTION_SECOND_TAG: 'Il tuo settore',
    REGISTER_SECTION_THIRD_TAG: 'Il tuo livello professionale prescelto',
    SEARCH_AND_SWIPE_SEARCH_WITH_AI: "Trova il tuo nuovo lavoro grazie all'IA",
    SEO_SECTION_TITLE: 'Trai ispirazione per la tua ricerca lavoro',
    TITLE_CARD_1: 'Offerte per posizioni da remoto',
    TITLE_CARD_2: 'Offerte con orari di lavoro flessibili',
    TITLE_CARD_3:
      'Offerte per chi è interessato a cambiare ambito professionale ',
    TITLE_CARD_4: 'Offerte con stipendi elevati',
    TITLE_CARD_5: 'Offerte part-time',
    TITLE_CARD_6: ' mini-lavoro',
    WELCOME_APP_MINIREG_ERROR_EMAIL: "Verifica l'indirizzo e-mail inserito.",
    WELCOME_APP_MINIREG_ERROR_FIRST_NAME: 'Immetti il tuo nome.',
    WELCOME_APP_MINIREG_ERROR_LAST_NAME: 'Immetti il tuo cognome.',
    WELCOME_APP_MINIREG_ERROR_PASSWORD_EMAIL:
      'Per ragioni di sicurezza dovresti scegliere una password diversa dal tuo indirizzo e-mail.',
    WELCOME_APP_MINIREG_ERROR_PASSWORD_LAST_NAME:
      'Per ragioni di sicurezza dovresti scegliere una password diversa dal tuo cognome.',
    WELCOME_APP_MINIREG_ERROR_PASSWORD_TOO_LONG:
      'La tua password può contenere un massimo di 1024 caratteri.',
    WELCOME_APP_MINIREG_ERROR_PHONE:
      'Verifica nuovamente il numero di telefono inserito.',
    WELCOME_APP_MINIREG_ERROR_TANDC:
      "È necessario confermare l'accettazione dei Termini e condizioni e della Privacy Policy del sito.",
    WELCOME_COMPLETION_HEADLINE: 'Benvenuto/a su XING!',
    WELCOME_COMPLETION_PAGE_META_TITLE: 'Benvenuto/a su XING! | XING',
    WELCOME_COMPLETION_SUBLINE:
      'Per completare la registrazione completa queste informazioni:',
    WELCOME_COMPLETION_SUBLINE_B:
      'Per completare la registrazione completa queste informazioni:',
    WELCOME_COMPLETION_SUBLINE_C:
      'Per completare la registrazione completa queste informazioni:',
    WELCOME_COMPLETION_SUBLINE_D:
      'Per completare la registrazione completa queste informazioni:',
    WELCOME_COMPLETION_SUBLINE_E:
      'Per completare la registrazione completa queste informazioni:',
    WELCOME_CONFIRMATION_DEFAULT_BOUNCED_BODY:
      'Per favore verifica nuovamente il tuo indirizzo-mail. Se è corretto, allora {link}.',
    WELCOME_CONFIRMATION_DEFAULT_BOUNCED_CTA: "Correggi l'indirizzo e-mail",
    WELCOME_CONFIRMATION_DEFAULT_BOUNCED_HEADER: 'Invio e-mail non riuscito.',
    WELCOME_CONFIRMATION_DEFAULT_BOUNCED_SUPPORT_LINK_TEXT: 'Contattaci',
    WELCOME_CONFIRMATION_DEFAULT_BUTTON: "Non hai ricevuto l'email?",
    WELCOME_CONFIRMATION_DEFAULT_COPY_1: 'Conferma il tuo account:',
    WELCOME_CONFIRMATION_DEFAULT_COPY_1_C:
      "Abbiamo appena inviato un'e-mail a {email}.*",
    WELCOME_CONFIRMATION_DEFAULT_COPY_1_D: 'Attiva il tuo account:',
    WELCOME_CONFIRMATION_DEFAULT_COPY_2:
      'Abbiamo inviato il relativo link a {email}. *',
    WELCOME_CONFIRMATION_DEFAULT_COPY_2_C:
      'Clicca sul link per confermare il tuo indirizzo e-mail.',
    WELCOME_CONFIRMATION_DEFAULT_COPY_2_D:
      'Abbiamo inviato il relativo link a {email}. *',
    WELCOME_CONFIRMATION_DEFAULT_HEADLINE: 'Quasi fatto!',
    WELCOME_CONFIRMATION_DEFAULT_HEADLINE_C: "C'è posta per te:",
    WELCOME_CONFIRMATION_DEFAULT_HEADLINE_D: 'Per la tua sicurezza ...',
    WELCOME_CONFIRMATION_DEFAULT_SUFFIX:
      '* Non hai ricevuto niente? Controlla i messaggi nella cartella Spam.',
    WELCOME_CONFIRMATION_EDIT_EMAIL_BUTTON: 'Invia nuovo link di attivazione',
    WELCOME_CONFIRMATION_EDIT_EMAIL_COPY:
      'Se così non fosse, lo puoi modificare qui di seguito:',
    WELCOME_CONFIRMATION_EDIT_EMAIL_HEADLINE:
      'È questo il tuo indirizzo email?',
    WELCOME_CONFIRMATION_EDIT_EMAIL_LABEL: 'E-mail',
    WELCOME_CONFIRMATION_EDIT_EMAIL_REQUEST_ERROR:
      'Spiacenti ma si è verificato un errore. Per favore, tenta nuovamente. ',
    WELCOME_CONFIRMATION_EMAIL_RESENT_BUTTON:
      "Non hai ancora ricevuto l'email?",
    WELCOME_CONFIRMATION_EMAIL_RESENT_COPY_1:
      'Ti abbiamo inviato un nuovo link di attivazione a: {email}',
    WELCOME_CONFIRMATION_EMAIL_RESENT_COPY_2:
      'Termina la registrazione cliccando sul link di attivazione che troverai nella tua posta in arrivo.',
    WELCOME_CONFIRMATION_EMAIL_RESENT_HEADLINE: 'Adesso si:',
    WELCOME_CONFIRMATION_PAGE_META_TITLE: 'Attiva il tuo account XING | XING',
    WELCOME_GDPR_IMG_ALT:
      'Le norme per la tutela della privacy di XING sono conformi alle normative RGPD.',
    WELCOME_INVITATION_HEADLINE: '{firstname} {lastname} ti invita.',
    WELCOME_INVITATION_SUBLINE:
      'Registrati qui per accettare la richiesta di contatto di {firstname}.',
    WELCOME_LANGUAGE_PAGE_META_TITLE: 'Seleziona la lingua | XING',
    WELCOME_LANGUAGE_SELECT_ENGLISH_LABEL: 'English',
    WELCOME_LANGUAGE_SELECT_FRENCH_LABEL: 'Français',
    WELCOME_LANGUAGE_SELECT_GERMAN_LABEL: 'Deutsch',
    WELCOME_LANGUAGE_SELECT_HEADLINE:
      'In quale lingua desideri utilizzare XING?',
    WELCOME_LANGUAGE_SELECT_ITALIAN_LABEL: 'Italiano',
    WELCOME_LANGUAGE_SELECT_SPANISH_LABEL: 'Español',
    WELCOME_LOGIN_FORM_EMAIL_REQUIRED_ERROR: 'Indica il tuo indirizzo e-mail.',
    WELCOME_LOGIN_FORM_FIRSTNAME_REQUIRED_ERROR: 'Indica il tuo nome.',
    WELCOME_LOGIN_FORM_LASTNAME_REQUIRED_ERROR: 'Indica il tuo cognome.',
    WELCOME_LOGIN_FORM_PASSWORD_REQUIRED_ERROR: 'Indica la tua password.',
    WELCOME_LOGIN_FORM_PASSWORD_REQURED_ERROR: 'Indica la tua password.',
    WELCOME_LOGIN_FORM_REMEMEMBER_ME_LABEL: 'Rimani connesso',
    WELCOME_LOGIN_FORM_SUBMIT_REQUEST_ERROR:
      'Spiacenti, si è verificato un errore. Riprova.',
    WELCOME_LOGIN_FORM_USERNAME_REQUIRED_ERROR:
      'Inserisci il tuo indirizzo e-mail.',
    WELCOME_LOGIN_HEADLINE: 'Bentornato/a!',
    WELCOME_LOGIN_PASSWORD_LABEL: 'Password',
    WELCOME_LOGIN_PROBLEMS_LOGGING_IN: 'Non riesci ad effettuare il login?',
    WELCOME_LOGIN_SUBMIT_LABEL: 'Accedi',
    WELCOME_LOGIN_USERNAME_LABEL: 'E-mail',
    WELCOME_REGISTRATION_CTA_REG_7503_E: 'Crea nuovo profilo',
    WELCOME_REGISTRATION_CTA_REG_7504_A: 'Avanti',
    WELCOME_REGISTRATION_CTA_REG_7504_B: 'Registrati',
    WELCOME_REGISTRATION_CTA_REG_7504_C: 'Registrati subito',
    WELCOME_REGISTRATION_CTA_REG_7504_D: 'Crea profilo',
    WELCOME_REGISTRATION_CTA_REG_7504_E: 'Iscriviti a XING',
    WELCOME_REGISTRATION_DATAPROTECTION_LABEL: "l'Informativa sulla privacy",
    WELCOME_REGISTRATION_DATAPROTECTION_LINK:
      'https://privacy.xing.com/en/privacy-policy',
    WELCOME_REGISTRATION_EMAIL_LABEL: 'E-mail',
    WELCOME_REGISTRATION_FIRSTNAME_LABEL: 'Nome',
    WELCOME_REGISTRATION_HEADLINE: 'Crea il tuo profilo XING gratuito:',
    WELCOME_REGISTRATION_HEADLINE_REG_7088_B:
      'Fai subito la registrazione, è gratuita e richiede solo 2 minuti!',
    WELCOME_REGISTRATION_HEADLINE_REG_7088_C:
      'Fai subito la registrazione, è gratuita e richiede solo 2 minuti!',
    WELCOME_REGISTRATION_HEADLINE_REG_7088_D:
      'Fai subito la registrazione, è gratuita e richiede solo 2 minuti!',
    WELCOME_REGISTRATION_HEADLINE_REG_7088_E:
      'Fai subito la registrazione, è gratuita e richiede solo 2 minuti!',
    WELCOME_REGISTRATION_HEADLINE_REG_7396_B:
      'Fai subito la registrazione, è gratuita e richiede solo 2 minuti!',
    WELCOME_REGISTRATION_HEADLINE_REG_7396_C:
      'Fai subito la registrazione, è gratuita e richiede solo 2 minuti!',
    WELCOME_REGISTRATION_HEADLINE_REG_7396_D:
      'Fai subito la registrazione, è gratuita e richiede solo 2 minuti!',
    WELCOME_REGISTRATION_HEADLINE_REG_7550_CMP:
      'Registrati e prova Premium gratis per 30 giorni',
    WELCOME_REGISTRATION_IGNORE_SOFT_EMAIL_ERRORS_LABEL:
      'si, {email} è il mio indirizzo e-mail corretto.',
    WELCOME_REGISTRATION_LASTNAME_LABEL: 'Cognome',
    WELCOME_REGISTRATION_PASSWORD_LABEL: 'Password',
    WELCOME_REGISTRATION_RECAPTCHA_HEADLINE: 'Quasi fatto!',
    WELCOME_REGISTRATION_RECAPTCHA_PARAGRAPH:
      'Per poter evitare che tu e gli altri utenti riceviate spam, dobbiamo verificare che tu sia una persona e non un robot.',
    WELCOME_REGISTRATION_SOFT_EMAIL_ERROR:
      'Verifica nuovamente che il tuo indirizzo e-mail sia corretto.',
    WELCOME_REGISTRATION_SUBMIT_LABEL: 'Avanti',
    WELCOME_REGISTRATION_TANDC_DESCRIPTION:
      'Dichiaro di accettare le {tandc} e {dataprotection}.',
    WELCOME_REGISTRATION_TANDC_LABEL: 'Termini e condizioni',
    WELCOME_REGISTRATION_TIMER_CAPTCHA_BUTTON:
      'Fai clic qui e tieni premuto per 5 secondi',
    WELCOME_REGISTRATION_TIMER_CAPTCHA_ERROR:
      'Spiacenti, si è verificato un errore. Clicca sul tasto e tienilo premuto per 5 secondi.',
    WELCOME_REGISTRATION_TIMER_CAPTCHA_HEADLINE: "Un'ultima verifica",
    WELCOME_REGISTRATION_TIMER_CAPTCHA_PARAGRAPH:
      'Per essere sicuri che tu sia una persona reale e non un bot, tieni premuto questo testo per 5 secondi.',
    WELCOME_REGISTRATION_VIA_CV_BAD_FILE_ERROR_LABEL:
      'Non è stato possibile caricare il file NameOfFile.pdf. È probabile che la dimensione del file sia troppo grande oppure che il formato prescelto non sia supportato.',
    WELCOME_REGISTRATION_VIA_CV_BUTTON_LABEL: 'Seleziona e carica file',
    WELCOME_REGISTRATION_VIA_CV_COMMON_ERROR_LABEL:
      'Si è verificato un errore. Per favore, tenta nuovamente.',
    WELCOME_REGISTRATION_VIA_CV_DESCRIPTION_DEFAULT:
      'Carica il tuo curriculum. Provvederemo a trasferire in automatico i tuoi dati al tuo profilo XING.',
    WELCOME_REGISTRATION_VIA_CV_DESCRIPTION_SUCCESS:
      'Abbiamo trasferito in automatico i tuoi dati al tuo profilo XING..{br}{br} Verifica se tutte le informazioni sono state incluse ed eventualmente compila i dati mancanti.',
    WELCOME_REGISTRATION_VIA_CV_FILE_INFO_LABEL:
      'Formato: PDF-, Word- (.docx) oppure documento Pages (max. 100 MB)',
    WELCOME_REGISTRATION_VIA_CV_HEADLINE_DEFAULT:
      'Avanza rapidamente (opzionale)',
    WELCOME_REGISTRATION_VIA_CV_HEADLINE_SUCCESS: 'Il tuo curriculum',
    WELCOME_SEARCHPAGE_CTA:
      'Trova il tuo prossimo lavoro oppure contatta amici e colleghi:',
    WELCOME_SEARCHPAGE_HEADLINE: 'Trova offerte o utenti:',
    WELCOME_SEARCHPAGE_JOBS_BUTTON: 'Lavori',
    WELCOME_SEARCHPAGE_JOBS_PLACEHOLDER:
      'Inserisci una posizione lavorativa o una parola chiave',
    WELCOME_SEARCHPAGE_MEMBERS_BUTTON: 'Utenti',
    WELCOME_SEARCHPAGE_MEMBERS_PLACEHOLDER:
      'Indica nome, azienda o termine di ricerca',
    WELCOME_SEARCHPAGE_SEARCH_BUTTON: 'Cerca',
    WELCOME_SIGNUP_FORM_SUBMIT_REQUEST_ERROR:
      'Spiacenti ma si è verificato un errore. Per favore, tenta nuovamente. \n',
    WELCOME_SIGNUP_FORM_VALIDATE_RELOAD_ERROR:
      'Si è verificato un errore. Assicurati che i cookie siano abilitati, aggiorna la pagina e tenta nuovamente.',
    WELCOME_SIGNUP_FORM_VALIDATE_REQUEST_ERROR:
      'Spiacenti ma si è verificato un errore. Per favore, tenta nuovamente. ',
    WELCOME_SIGNUP_PAGE_META_TITLE: 'Registrati gratuitamente | XING',
    WELCOME_SIGNUP_USP_CONTACTS_COPY:
      'Entra in contatto con oltre 21 milioni di utenti.',
    WELCOME_SIGNUP_USP_CONTACTS_TITLE: 'Contatti importanti',
    WELCOME_SIGNUP_USP_FREE_COPY:
      "L'abbonamento standard di XING è e rimarrà gratuito.",
    WELCOME_SIGNUP_USP_FREE_TITLE: 'Registrazione gratuita',
    WELCOME_SIGNUP_USP_PRESENCE_COPY:
      'Trova il lavoro dei tuoi sogni con XING.',
    WELCOME_SIGNUP_USP_PRESENCE_TITLE: 'Oltre un milione di offerte',
    WELCOME_SIGNUP_USP_SECURITY_COPY:
      'Affidati su XING alla legge tedesca in materia di protezione dei dati.',
    WELCOME_SIGNUP_USP_SECURITY_TITLE: 'Massima sicurezza',
    WELCOME_SIGNUP_USPS_TITLE: 'XING – il tuo partner professionale',
    WELCOME_STARTPAGE_APP_STORE_BADGE_ALT: "Scarica nell'App Store ",
    WELCOME_STARTPAGE_CULTURE_CHECK_BUTTON:
      "Vai all'analisi della cultura aziendale",
    WELCOME_STARTPAGE_CULTURE_CHECK_IMG_ALT:
      'Un grafico che descrive la cultura aziendale.',
    WELCOME_STARTPAGE_CULTURE_CHECK_TEXT:
      "Gerarchie orizzontali o chiare indicazioni? Più spazio per la vita privata e per quella lavorativa? Sono molti i fattori che determinano una determinata cultura aziendale. \nCon l'analisi della cultura aziendale potrai scoprire qual'è la cultura adatta a te e saprai esattamente cosa cercare la prossima volta che vorrai cambiare lavoro. Dai subito un'occhiata: \nadatta a noi è fondamentale per sentirsi a proprio agio sul lavoro. Scopri quale cultura aziendale è adatta a te completando il nostro test.\n",
    WELCOME_STARTPAGE_CULTURE_CHECK_TITLE:
      'Trova lavoro dove ti senti a tuo agio.',
    WELCOME_STARTPAGE_CULTURE_COMPASS_BUTTON: 'Vai alla bussola culturale',
    WELCOME_STARTPAGE_CULTURE_COMPASS_IMG_ALT:
      'Un grafico che rappresenta la cultura aziendale su una scala che spazia da quella tradizionale fino a quella moderna.',
    WELCOME_STARTPAGE_CULTURE_COMPASS_TEXT:
      "Ti sai mai chiesto come sia la vita professionale dei dipendenti che lavorano presso l'azienda dei tuoi sogni? La bussola culturale te lo può svelare. Scoprirai inoltre se una determinata società ha un'impronta tradizionale o moderna e se da spazio esclusivamente al lavoro o anche alla qualità di vita dei propri dipendenti. Scopri interessanti informazioni per poter trovare un lavoro che garantisce un equilibrio ottimale fra vita privata e lavorativa.",
    WELCOME_STARTPAGE_CULTURE_COMPASS_TITLE: 'Segui la bussola culturale',
    WELCOME_STARTPAGE_DOWNLOAD_APP_CTA: "Pronto per l'App di XING?",
    WELCOME_STARTPAGE_FORM_TITLE_REG_7371_01:
      'Registrati gratuitamente in soli 2 minuti:',
    WELCOME_STARTPAGE_FORM_TITLE_REG_7371_02:
      'Registrati gratuitamente in soli 2 minuti:',
    WELCOME_STARTPAGE_FORM_TITLE_REG_7371_03:
      'Effettua la sottoscrizione gratuita in soli 2 minuti:',
    WELCOME_STARTPAGE_FORM_TITLE_REG_7371_04:
      'Registrati gratuitamente in soli 2 minuti:',
    WELCOME_STARTPAGE_GOOGLE_PLAY_BADGE_ALT: 'Ora su Google Play',
    WELCOME_STARTPAGE_HEADER_BUTTON: 'Registrati subito',
    WELCOME_STARTPAGE_HEADER_IMAGE_ALT:
      'Una donna sorridente seduta comodamente su una sedia',
    WELCOME_STARTPAGE_HEADER_SUBTITLE: 'Crea il tuo proprio XING!',
    WELCOME_STARTPAGE_HEADER_TITLE:
      'È il momento di dare spazio al tuo sviluppo professionale.',
    WELCOME_STARTPAGE_JOBS_DIRECTORY_NAVIGATION_TITLE: 'Offerte dalla A alla Z',
    WELCOME_STARTPAGE_JOBS_VERSION_HEADER_BUTTON: 'Iscriviti gratuitamente',
    WELCOME_STARTPAGE_JOBS_VERSION_HEADER_SUBTITLE:
      '...o possiamo effettuare noi una ricerca per te! Prova subito:',
    WELCOME_STARTPAGE_JOBS_VERSION_HEADER_TITLE:
      'Trova il lavoro {br}\nperfetto per te:',
    WELCOME_STARTPAGE_JOBS_VERSION_JOB_FILTER_DOGS_FRIENDLY: 'Cani ammessi',
    WELCOME_STARTPAGE_JOBS_VERSION_JOB_FILTER_FLEXIBILITY:
      'Orari di lavoro flessibili',
    WELCOME_STARTPAGE_JOBS_VERSION_JOB_FILTER_PART_TIME: 'Part time',
    WELCOME_STARTPAGE_JOBS_VERSION_JOB_FILTER_REMOTE: 'Home office ',
    WELCOME_STARTPAGE_JOBS_VERSION_JOB_INPUT_PLACEHOLDER:
      'Immetti posizione lavorativa o parola chiave',
    WELCOME_STARTPAGE_JOBS_VERSION_LOCATION_INPUT_PLACEHOLDER: 'Località',
    WELCOME_STARTPAGE_JOBS_VERSION_SEARCH_SUBMIT_BUTTON: 'Trova un impiego',
    WELCOME_STARTPAGE_JOBS_VERSION_SECTION_ONE_IMG_ALT:
      'Disegno di una persona e di un curriculum',
    WELCOME_STARTPAGE_JOBS_VERSION_SECTION_ONE_TEXT:
      "Che sia l'aspirazione ad un cambio di città, stile di vita o semplicemente la voglia di qualcosa di nuovo: XING rappresenta l'opportunità di un cambiamento nella tua vita professionale. Per poter dare il meglio di sé senza dover scendere a compromessi.",
    WELCOME_STARTPAGE_JOBS_VERSION_SECTION_ONE_TITLE:
      'Su XING sei molto di più di un semplice CV',
    WELCOME_STARTPAGE_JOBS_VERSION_SECTION_THREE_IMG_ALT:
      "Disegno rappresentante una persona con un'immagine nella quale si possono vedere diversi volti",
    WELCOME_STARTPAGE_JOBS_VERSION_SECTION_THREE_TEXT:
      "Con un semplice messaggio potrai raggiungere oltre 20.000 recruiter su XING. Qui potrai trovare i responsabili HR, gli esperti del settore desiderato e i maggiori professionisti del mercato del lavoro e potrai stabilire un contatto diretto con i recruiter e i dipendenti dell'azienda dei tuoi sogni. Unisciti a XING!",
    WELCOME_STARTPAGE_JOBS_VERSION_SECTION_THREE_TITLE:
      'Stabilisci i contatti adeguati',
    WELCOME_STARTPAGE_JOBS_VERSION_SECTION_TWO_IMG_ALT:
      'Disegno di una persona con diversi copricapo da lavoro',
    WELCOME_STARTPAGE_JOBS_VERSION_SECTION_TWO_TEXT:
      'Qui potrai trovare una miriade di interessanti offerte di lavoro. Ti verranno inoltre notificate quelle corrispondenti ai tuoi criteri di ricerca in maniera tempestiva. Scopri quello che vuoi veramente dalla tua vita professionale e quale tipo di sviluppo vuoi che abbia e trova le imprese che consideri più stimolanti e che condividono la cultura aziendale che prediligi.',
    WELCOME_STARTPAGE_JOBS_VERSION_SECTION_TWO_TITLE:
      'Oltre un Mln di offerte di lavoro e innumerevoli opportunità',
    WELCOME_STARTPAGE_JOBSFINDER_CTA_BUTTON: 'Registrati',
    WELCOME_STARTPAGE_JOBSFINDER_CTA_TEXT:
      'Quanto incidono luogo e settore di lavoro sulla fascia salariale? Scoprilo su XING.',
    WELCOME_STARTPAGE_JOBSFINDER_IMG_ALT:
      'Una donna tenta di lavorare in una posizione palesemente scomoda',
    WELCOME_STARTPAGE_JOBSFINDER_SUBTITLE: 'Sii te stesso:',
    WELCOME_STARTPAGE_JOBSFINDER_SUGGESTION_CONSULTING: 'Consulenza',
    WELCOME_STARTPAGE_JOBSFINDER_SUGGESTION_IT: 'IT',
    WELCOME_STARTPAGE_JOBSFINDER_SUGGESTION_LOGISTICS: 'logistica',
    WELCOME_STARTPAGE_JOBSFINDER_SUGGESTION_MARKETING: 'Marketing',
    WELCOME_STARTPAGE_JOBSFINDER_SUGGESTION_MORE_JOBS: 'Altri settori',
    WELCOME_STARTPAGE_JOBSFINDER_SUGGESTION_PROJECT_MANAGEMENT:
      'Project management',
    WELCOME_STARTPAGE_JOBSFINDER_TITLE: 'Trova il lavoro perfetto per te!',
    WELCOME_STARTPAGE_KEY_FEATURES_EVENTS: '1,7 milioni di eventi',
    WELCOME_STARTPAGE_KEY_FEATURES_JOBS: 'Oltre 250.000 posti di lavoro',
    WELCOME_STARTPAGE_KEY_FEATURES_MEMBERS: '21 milioni di iscritti',
    WELCOME_STARTPAGE_KEY_FEATURES_NEWS: 'Nuove notizie di settore ogni giorno',
    WELCOME_STARTPAGE_MAIN_CTA_BUTTON: 'Registrati subito gratuitamente\n',
    WELCOME_STARTPAGE_MAIN_CTA_TEXT:
      'XING: Il maggiore network professionale online nei paesi di lingua tedesca.',
    WELCOME_STARTPAGE_MAIN_DESCRIPTION:
      'XING è il tuo assistente professionale personale con cui potrai stabilire nuovi contatti di lavoro e scoprire fantastiche offerte di impiego, eventi, news e gruppi.',
    WELCOME_STARTPAGE_MAIN_DESCRIPTION_REG_7088_B:
      'Trova un lavoro in linea con il tuo stile di vita',
    WELCOME_STARTPAGE_MAIN_DESCRIPTION_REG_7088_C:
      'Un luogo, molte persone interessanti. Scopri tutte le novità, condividi le tue idee e lasciati ispirare.',
    WELCOME_STARTPAGE_MAIN_DESCRIPTION_REG_7088_D:
      'Fai subito la registrazione, è gratuita e richiede solo 2 minuti!',
    WELCOME_STARTPAGE_MAIN_DESCRIPTION_REG_7088_E:
      'Un punto di incontro per moltissime persone. Condividi idee, trai inspirazione dagli altri e rimani sempre informato sulle ultime novità.',
    WELCOME_STARTPAGE_MAIN_SUBTITLE_REG_7494:
      'Für Dein Leben. Für Deinen Job. Für Dein Job-Leben.',
    WELCOME_STARTPAGE_MAIN_TITLE:
      'XING – Idee per una nuova vita professionale',
    WELCOME_STARTPAGE_MAIN_TITLE_REG_7088_B:
      'trova il prossimo lavoro adatto a te',
    WELCOME_STARTPAGE_MAIN_TITLE_REG_7088_C:
      'Raggiungi gli obiettivi più ambiziosi grazie al tuo network.',
    WELCOME_STARTPAGE_MAIN_TITLE_REG_7088_D:
      'La tua situazione professionale? Deriva sempre da una buona rete di contatti.',
    WELCOME_STARTPAGE_MAIN_TITLE_REG_7088_E:
      'Conosci le persone giuste in ambito lavorativo.',
    WELCOME_STARTPAGE_MAIN_TITLE_REG_7371_01:
      'Trova il lavoro giusto per il tuo stile di vita.',
    WELCOME_STARTPAGE_MAIN_TITLE_REG_7371_02:
      'Dimentica i "forse..." e trova il lavoro adatto a te. ',
    WELCOME_STARTPAGE_MAIN_TITLE_REG_7371_03:
      'XING – il tuo partner professionale.',
    WELCOME_STARTPAGE_MAIN_TITLE_REG_7371_04:
      'Lavorare meglio per vivere meglio: trova il lavoro che fa per te.',
    WELCOME_STARTPAGE_MAIN_TITLE_REG_7494: 'Weil Du’s Dir vorgenommen hast.',
    WELCOME_STARTPAGE_MAIN_TITLE_REG_7747:
      'È il momento di dare spazio al tuo sviluppo professionale.{br}\nCrea il tuo proprio XING!',
    WELCOME_STARTPAGE_MEMBER_DIRECTORY_NAVIGATION_TITLE:
      'Cerca utenti per lettera iniziale',
    WELCOME_STARTPAGE_META_DESCRIPTION:
      'XING è il tuo assistente professionale personale con cui potrai stabilire nuovi contatti professionali, scoprire fantastiche offerte di lavoro e ottenere utili consigli sul mondo del lavoro.',
    WELCOME_STARTPAGE_META_DESCRIPTION_JOB_SEARCH:
      '✓ Analisi culturale ✓ Valutazioni datori di lavoro ✓ e-Learning ✓ Contatto con i recruiter - Crea il tuo proprio XING e rendi la tua vita professionale più soddisfacente \n',
    WELCOME_STARTPAGE_META_TITLE:
      'XING – Idee per una nuova vita professionale',
    WELCOME_STARTPAGE_META_TITLE_JOB_SEARCH: 'XING: trova il tuo lavoro ideale',
    WELCOME_STARTPAGE_OG_SITENAME: 'XING',
    WELCOME_STARTPAGE_OG_TITLE: 'XING – Idee per una nuova vita professionale',
    WELCOME_STARTPAGE_PROCEED_WITH_APPLE_BUTTON: 'Continua con Apple',
    WELCOME_STARTPAGE_PROCEED_WITH_GOOGLE_BUTTON: 'Avanti con Google',
    WELCOME_STARTPAGE_XINGGUIDE_BUTTON: 'Scopri di più',
    WELCOME_STARTPAGE_XINGGUIDE_IMG_ALT:
      'Un messaggio di Guide XING contenente una segnalazione di offerta di lavoro ',
    WELCOME_STARTPAGE_XINGGUIDE_TEXT:
      'Stai cercando lavoro o hai appena cominciato un nuovo impiego? Allora la guida di XING ti fornirà utili consigli su come presentarti al meglio su XING. Scoprirai come perfezionare il tuo profilo, con quali utenti connetterti e quali articoli leggere.',
    WELCOME_STARTPAGE_XINGGUIDE_TITLE: 'Il tuo partner professionale',
    WELCOME_TOGGLE_FORM_BUTTON_LOGIN: 'Accedi',
    WELCOME_TOGGLE_FORM_BUTTON_REGISTER: 'Registrati',
    XAM_GENERIC_ERROR_MESSAGE:
      'Spiacenti, si è verificato un errore. Per favore, tenta nuovamente. ',
    XAM_LEAD_AD_CUSTOM_QUESTION_PLACEHOLDER: 'Indica qui la tua risposta.',
    XAM_LEAD_AD_FORM_THANKS_CTA_DOWNLOAD_NOW: 'Scaricala',
    XAM_LEAD_AD_FORM_THANKS_CTA_TRY_NOW: 'Provalo subito',
    XAM_LEAD_AD_FORM_THANKS_CTA_VISIT_COMPANY_WEBSITE:
      "Visualizza il sito web dell'azienda",
    XAM_LEAD_AD_FORM_THANKS_CTA_VISIT_NOW: 'Visita ',
    XAM_LEAD_AD_FORM_THANKS_CTA_VISIT_XING_PAGE: 'Visualizza pagina XING',
    XAM_LEAD_AD_PREVIEW_CONFIRMATION_SUCCESS_MESSAGE: 'Richiesta inviata',
    XAS_ARMSTRONG_LEAD_AD_FORM_THANKS_BUTTON_COPY: 'Visualizza pagina XING',
    XDS_EMPTYSTATE_ERROR_BUTTON: 'Tenta nuovamente',
    XDS_EMPTYSTATE_ERROR_DESCRIPTION: 'Sei pregato di tentare nuovamente.',
    XDS_EMPTYSTATE_ERROR_TITLE: 'Spiacenti, si è verificato un errore.',
  },
};
